// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.patient.family.UpdateFamilyAccountMemberWithEmergencyContactRequest */
/* istanbul ignore next */
@GandalfModel
export class UpdateFamilyAccountMemberWithEmergencyContactRequest extends GandalfModelBase {

	@GandalfLabel('Family Account member')
	@GandalfValidator({ notNull: { message: 'Family Account member is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	familyAccountMemberId!: number;

	@GandalfLabel('Head of Household')
	@GandalfValidator({ notNull: { message: 'Head of Household is required' } })
	@GandalfProperty({ designType: Boolean, isRequired: true })
	headOfHousehold!: boolean;

	@GandalfLabel('Emergency Contact')
	@GandalfValidator({ notNull: { message: 'Emergency Contact is required' } })
	@GandalfProperty({ designType: Boolean, isRequired: true })
	isEmergencyContact!: boolean;

	@GandalfLabel('Primary emergency contact')
	@GandalfValidator({ notNull: { message: 'Primary emergency contact is required' } })
	@GandalfProperty({ designType: Boolean, isRequired: true })
	isPrimaryEmergencyContact!: boolean;

	@GandalfLabel('Patient')
	@GandalfValidator({ notNull: { message: 'Patient is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	ownerPatient!: number;

	@GandalfLabel('Role')
	@GandalfValidator({ notNull: { message: 'Role is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	roleId!: number;

}
